import React from 'react';
import { Tooltip } from '@material-ui/core';
import Fade from '@material-ui/core/Fade';
import { Button, ProgressBar } from '@adobe/react-spectrum';
import PropTypes from 'prop-types';
import lastUpdated from '../../../../utils/lastUpdated';
import { getRandomColor } from '../../utils';
import daysLeft from '../../../../utils/daysLeft';
import { getLocalDateTime } from '../../../../utils/utils';
import {
  Wrap,
  Header,
  Title,
  LastUpdate,
  ListHeader,
  Project,
  ProjectInfo,
  ProjectTitle,
  ProjectDaysLeft,
  HProject,
  HDays,
  Projects,
} from './styles';

const ProjectTimeline = ({ priorityProjects }) => {
  return (
    <Wrap>
      <Header>
        <Title>Project Timeline</Title>
        <LastUpdate>{lastUpdated()}</LastUpdate>
      </Header>
      <ListHeader>
        <HProject>Project</HProject>
        <HDays>Days left</HDays>
      </ListHeader>
      <Projects>
        {priorityProjects &&
          priorityProjects.length > 0 &&
          priorityProjects.map((project, index) => (
            <Project
              key={`${project.id}${index}`}
              color={getRandomColor()}
              days={project.days}
            >
              <ProjectInfo
                overdue={
                  daysLeft(
                    getLocalDateTime(project.project.plannedCompletionDate),
                  ) <= 0
                }
              >
                <Tooltip
                  title={project.name}
                  arrow
                  TransitionComponent={Fade}
                  TransitionProps={{ timeout: 600 }}
                  placement="left-end"
                >
                  <ProjectTitle>{project.project.name}</ProjectTitle>
                </Tooltip>

                <ProgressBar
                  label={
                    daysLeft(
                      getLocalDateTime(project.project.plannedCompletionDate),
                    ) < 0
                      ? 'Overdue'
                      : 'On time'
                  }
                  value={Math.floor(project.project.percentComplete)}
                />
              </ProjectInfo>
              <ProjectDaysLeft>
                {daysLeft(
                  getLocalDateTime(project.project.plannedCompletionDate, true),
                )}
              </ProjectDaysLeft>
            </Project>
          ))}
      </Projects>
      <Button variant="primary">View completed</Button>
    </Wrap>
  );
};

ProjectTimeline.propTypes = {
  priorityProjects: PropTypes.arrayOf(
    PropTypes.shape({
      project: PropTypes.shape({
        percentComplete: PropTypes.number,
      }),
      id: PropTypes.string,
      name: PropTypes.string,
      progressStatus: PropTypes.string,
      percentComplete: PropTypes.number,
    }),
  ),
};

ProjectTimeline.defaultProps = {
  priorityProjects: {
    project: {
      percentComplete: 0,
    },
    id: '',
    name: '',
    progressStatus: '',
    percentComplete: '',
  },
};

export default ProjectTimeline;
